import { Shield } from 'lucide-react';
import type { ReactNode, JSX } from 'react';

import styles from './AuthLayout.module.scss';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthLayout({ title, subtitle, children }: Props): JSX.Element {
  return (
    // OS-1725 C3 — landmark principal: las pantallas de acceso no usan AdminLayout (que ya tiene <main>).
    <main className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.logoMark}>
            <Shield size={20} aria-hidden="true" />
          </div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {children}
      </div>
    </main>
  );
}
